import {
  INode, HierarchyLevelType, IHierarchyAPIQuery, SecurityClassification,
} from 'common/interfaces/hierarchy-entities';
import { apiCallBegan } from 'client/store/middleware/api/api';
import {
  HierarchyEntityName, NodeCreateParentPayload, getHierarchyEntitiesAPICallAction, getHierarchyEntityAPICallAction,
} from '../helpers/hierarchy-api-actions-factory';
import { createHierarchyEntitySlice } from '../../hierarchy-state-slice-factory';

const slice = createHierarchyEntitySlice<INode>(HierarchyLevelType.Node);

export const {
  itemsRequested: nodesRequested,
  itemsRecieved: nodesRecieved,
  itemsFailed: nodesFailed,
  itemRecieved: nodeRecieved,
  itemDeleteRecieved: nodesDeleteRecieved,
  itemReset: nodesReset,
  classificationLevelUpdated,
} = slice.actions;

export default slice.reducer;

export const getNodes = (params: Partial<IHierarchyAPIQuery> & { parenttype: HierarchyLevelType }) => getHierarchyEntitiesAPICallAction(HierarchyEntityName.NODE, params, nodesRequested.type, nodesFailed.type, nodesRecieved.type);

export const getNode = (entityId: string, parentId: string) => getHierarchyEntityAPICallAction(HierarchyEntityName.NODE, { entityId, parentId }, nodesRequested.type, nodesFailed.type, nodeRecieved.type);

export const createNode = (data: Partial<INode & NodeCreateParentPayload>, getParentEntityAction: Function | null) => apiCallBegan({
  url: '/node',
  method: 'POST',
  data,
  onStart: () => ({ type: nodesRequested.type, payload: { parentId: '' } }),
  onSuccess: (response: { id: string; }) => {
    getParentEntityAction?.(response.id);
    return getNode(response.id, '');
  },
  onError: (e: any) => ({ type: nodesFailed.type, payload: { parentId: '', message: e.message } }),
});

// createNodeSchema (validates this PUT server-side) rejects owner/restricted/rights
export const updateNode = (data: Omit<INode, 'updated' | 'created' | 'owner' | 'restricted' | 'rights'>) => apiCallBegan({
  url: `/node/${data.nodeid}`,
  method: 'PUT',
  data,
  onStart: () => ({ type: nodesRequested.type, payload: { parentId: '' } }),
  onSuccess: (response: { id: string; }) => getNode(response.id, ''),
  onError: (e: any) => ({ type: nodesFailed.type, payload: { parentId: '', message: e.message } }),
});

export const deleteNode = (data: any) => apiCallBegan({
  url: `/node/${data.nodeid}`,
  method: 'DELETE',
  onStart: () => ({ type: nodesRequested.type, payload: { parentId: '' } }),
  onSuccess: () => ({
    type: nodesDeleteRecieved.type,
    payload: data.nodeid,
  }),
  onError: (e: any) => ({ type: nodesFailed.type, payload: { parentId: '', message: e.message } }),
});

export const getDesignNodes = (designid: string) => apiCallBegan({
  url: `design/node?designid=${designid}`,
  method: 'GET',
  onStart: () => ({ type: nodesRequested.type, payload: { parentId: designid } }),
  onSuccess: (response: INode[]) => ({
    type: nodesRecieved.type,
    payload: [{ records: response }, { parentId: designid }],
  }),
  onError: (e: any) => ({ type: nodesFailed, payload: { parentId: designid, message: e.message } }),
});

export const deleteDesignNode = (data: { designid: string, nodeid: string }) => apiCallBegan({
  url: 'design/node',
  method: 'DELETE',
  data,
  onStart: () => ({ type: nodesRequested.type, payload: { parentId: '' } }),
  onSuccess: () => ({
    type: nodesDeleteRecieved.type,
    payload: { entityId: data.nodeid },
  }),
  onError: (e: any) => ({ type: nodesFailed.type, payload: { parentId: '', message: e.message } }),
});

export const addDesignNode = (data: { designid: string, nodeid: string }) => apiCallBegan({
  url: 'design/node',
  method: 'PUT',
  data,
  onStart: () => ({ type: nodesRequested.type, payload: { parentId: '' } }),
  onSuccess: () => ({
    type: nodesDeleteRecieved.type,
    payload: { entityId: data.nodeid },
  }),
  onError: (e: any) => ({ type: nodesFailed.type, payload: { parentId: '', message: e.message } }),
});

export const updateNodeClassificationLevel = (data: { id: string, classificationlevel: SecurityClassification }) => apiCallBegan({
  url: '/node/classificationlevel',
  method: 'PUT',
  data,
  onStart: () => ({ type: nodesRequested.type, payload: { parentId: '' } }),
  // @ts-ignore
  onSuccess: (response) => ({
    type: classificationLevelUpdated.type,
    payload: response,
  }),
  onError: (e: any) => ({ type: nodesFailed.type, payload: { parentId: '', message: e.message } }),
});
